import { EventObject } from "../../../util/event/EventObject";
/**
 * CommonOperatorEvent.ts
 */
export class CommonOperatorEvent {
}
CommonOperatorEvent.HELP_OPEN = new EventObject("CommonOperatorEvent.HELP_OPEN");
CommonOperatorEvent.HELP_CLOSE = new EventObject("CommonOperatorEvent.HELP_CLOSE");
CommonOperatorEvent.SOUND_ON = new EventObject("CommonOperatorEvent.SOUND_ON");
CommonOperatorEvent.SOUND_OFF = new EventObject("CommonOperatorEvent.SOUND_OFF");
CommonOperatorEvent.PAY_TABLE_OPEN = new EventObject("CommonOperatorEvent.PAY_TABLE_OPEN");
CommonOperatorEvent.PAY_TABLE_CLOSE = new EventObject("CommonOperatorEvent.PAY_TABLE_CLOSE");
CommonOperatorEvent.BALANCE_HAS_CHANGED = new EventObject("CommonOperatorEvent.BALANCE_HAS_CHANGED");
CommonOperatorEvent.STOP_AUTO_SPINS = new EventObject("CommonOperatorEvent.STOP_AUTO_SPINS");
CommonOperatorEvent.OPERATOR_DATA = new EventObject("CommonOperatorEvent.OPERATOR_DATA");
CommonOperatorEvent.WRAPPER_OBJECT = new EventObject("CommonOperatorEvent.WRAPPER_OBJECT");
//# sourceMappingURL=CommonOperatorEvent.js.map